/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wpzv2br%7Balign-self%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1k92%7Bheight%3A1.25rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1h6o%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx2vrvc%7Bflex-direction%3Arow%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zulputpp%7Bgap%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m915vq%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo15vq%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul9idpf%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._p12f1osq%7Bmax-width%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c116y%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pbykb7n%7Bz-index%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswh2mm%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ahbq1i6y%7Bmargin-inline-start%3Avar(--ds-space-negative-025%2C-2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._o5721q9c%7Bwhite-space%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zidpf%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2hwx12x7%7Bmargin-right%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhkjmqp%7Bbackground-color%3Avar(--ds-background-selected-bold%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3iftgi%7Bheight%3A8px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsbftgi%7Bwidth%3A8px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1rr0%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._7ehi1x61%3Afocus%7Bbox-shadow%3A0%200%200%20var(--ds-border-width%2C1px)%20var(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._858u1v1w%3Afocus%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19bv1b66%7Bpadding-left%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._n3td1b66%7Bpadding-bottom%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u5f312x7%7Bpadding-right%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ca0q1b66%7Bpadding-top%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._k48p1wq8%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vchhusvi%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12y31o36%7Boutline-width%3Amedium%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1qu2glyw%7Boutline-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._12ji1r31%7Boutline-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko12b0%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19itno8c%7Bborder%3Avar(--ds-border-width%2C1px)%20solid%20var(--ds-border-input%2C%238c8f97)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8fhey%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19pkx0bf%7Bmargin-top%3Avar(--ds-space-negative-100%2C-8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zulp1b66%7Bgap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19it145i%7Bborder%3Avar(--ds-border-width%2C1px)%20solid%20transparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozgze3t%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D");
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { bind } from 'bind-event-listener';
import { useIntl } from 'react-intl';
import { IconButton } from '@atlaskit/button/new';
import type { EmojiProvider } from '@atlaskit/emoji';
import { ResourcedEmoji } from '@atlaskit/emoji/element';
import Form, { Field } from '@atlaskit/form';
import FolderAddIcon from '@atlaskit/icon-lab/core/folder-add';
import ViewAllIcon from '@atlaskit/icon/core/align-text-left';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import CrossIcon from '@atlaskit/icon/core/cross';
import DeleteIcon from '@atlaskit/icon/core/delete';
import EditIcon from '@atlaskit/icon/core/edit';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import MoreIcon from '@atlaskit/icon/core/show-more-horizontal';
import { ButtonItem, MenuGroup, Section } from '@atlaskit/menu';
import { fg } from '@atlaskit/platform-feature-flags';
import { Popup } from '@atlaskit/popup';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import type { AgentCreatorType } from '@atlaskit/rovo-agent-components/common/types';
import { isForgeAgentByCreatorType } from '@atlaskit/rovo-agent-components/common/utils/is-forge-agent';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import { COLLAPSE_ELEM_BEFORE as ATLAS_COLLAPSE_ELEM_BEFORE } from '@atlaskit/side-nav-items/link-menu-item';
import { MenuList as AtlasMenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuSection as AtlasMenuSection, MenuSectionHeading as AtlasMenuSectionHeading } from '@atlaskit/side-nav-items/menu-section';
import Spinner from '@atlaskit/spinner';
import Tooltip from '@atlaskit/tooltip';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation/controllers/analytics';
import { useStagingAreaActions } from '@atlassian/conversation-assistant-store/controllers/staging-area';
import { getChatItemIcon } from '@atlassian/conversation-assistant-ui-components/ui/chat-conversation-list-refresh/getChatItemIcon';
import { ScopeRow } from '@atlassian/conversation-assistant-ui-components/ui/chat-conversation-list-refresh/scope-row';
import { ScopeFileBlobPreviewModal } from '@atlassian/conversation-assistant-ui-components/ui/chat-conversation-list-refresh/ScopeFileBlobPreviewModal';
import { useUpdateTime } from '@atlassian/conversation-assistant-ui-components/ui/chat-conversation-list/useUpdateTime';
import { ConversationListRowStatusChip, ConversationStatusLabel, shouldShowConversationTaskStatusFooter } from '@atlassian/conversation-assistant-ui-components/ui/conversation-status-label';
import { isTaskStatusLoadingForConversationRow } from '@atlassian/conversation-assistant-ui-components/utils/conversation-task-status-indicator';
import { useSpaces, useSpacesLoading } from '@atlassian/rovo-spaces/controllers/space-store';
import type { Space } from '@atlassian/rovo-spaces/controllers/space-store/types';
import { createEmojiProvider } from '@atlassian/rovo-spaces/utils/emoji-provider';
import { COLLAPSE_ELEM_BEFORE, TESTID_PREFIX, Z_INDEX_POPUP_COMPONENTS } from '../../../common/constants';
import commonMessages from '../../../common/messages';
import type { Conversation, ConversationListProps } from '../../../common/types';
import { ButtonMenuItem } from '../../../common/ui/button-menu-item';
import { LinkMenuItem } from '../../../common/ui/link-menu-item';
import { List } from '../../../common/ui/list';
import { MenuSection } from '../../../common/ui/menu-section';
import { MenuSectionHeading } from '../../../common/ui/menu-section/menu-section-heading';
import { type ConversationGroup, groupConversationsByTime } from '../../../common/utils/date-utils';
import messages from './messages';
const listStyles = {
  noPaddingInlineStart: "_bozgze3t"
};
const styles = {
  renameForm: "_19it145i _1e0c1txw",
  innerForm: "_zulp1b66 _1bsb1osq _1e0c1txw _4cvr1h6o",
  textFieldContainer: "_16jlkb7n _19pkx0bf",
  textField: "_11c8fhey _19itno8c _2rko12b0 _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _vchhusvi _k48p1wq8 _ca0q1b66 _u5f312x7 _n3td1b66 _19bv1b66 _858u1v1w _7ehi1x61",
  notificationDot: "_2rko1rr0 _1bsbftgi _4t3iftgi _bfhkjmqp",
  statusContainer: "_2hwx12x7",
  scopeOverflowCount: "_1o9zidpf _o5721q9c _ahbq1i6y",
  firstScopeTooltipTrigger: "_kqswh2mm _1pbykb7n _1e0c116y _4cvr1h6o _p12f1osq _1ul9idpf",
  scopeNameWrapper: "_1reo15vq _18m915vq _1ul9idpf",
  elemAfterStyles: "_zulputpp _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1h6o _4t3i1k92 _1wpzv2br"
};
export type ChatListMenuItemsProps = ConversationListProps & {
  level?: number;
  isADSNavigationEnabled: boolean;
  isNewAllConversationScreenEnabled?: boolean;
  isSpinnerOverlayConversationIconEnabled?: boolean;
  /**
   * When true, renders the new task-aware design: hides the left icon and shows
   * the running task's current step as a shimmer trace below the title.
   * Controlled by the `rovo_chat_enable_tasks` FG.
   */
  isNewDesignEnabled?: boolean;
  cloudId?: string;
};
export const ChatListMenuItems = ({
  conversations = [],
  currentConversation,
  onViewAllConversations,
  isADSNavigationEnabled,
  isNewAllConversationScreenEnabled = false,
  isSpinnerOverlayConversationIconEnabled = false,
  isNewDesignEnabled = false,
  cloudId = '',
  ...props
}: ChatListMenuItemsProps): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const filteredConversations = React.useMemo(() => conversations.filter(convo => !convo.isEmpty && (
  // Exclude space-scoped conversations from the regular list — they are
  // rendered inside `SpaceMenuItems` instead.
  !fg('rovo_chat_spaces_fe') || !convo.rovoSpaceId)), [conversations]);
  const groupedConversations = React.useMemo(() => groupConversationsByTime(filteredConversations, formatMessage), [filteredConversations, formatMessage]);
  const onViewAllConversationsClick = useCallback(() => {
    onViewAllConversations();
  }, [onViewAllConversations]);
  const spaces = useSpaces();
  const isLoadingSpaces = useSpacesLoading();
  const spaceEmojiProvider = useMemo(() => createEmojiProvider(cloudId), [cloudId]);
  const renderConversationList = (group: ConversationGroup, groupIndex: number) => {
    const listItems = group.conversations.map((convo, i) => <ChatListItem isADSNavigationEnabled={isADSNavigationEnabled} key={convo.id} testIdDisambiguator={`${groupIndex}-${i}`} conversation={convo} isSelected={convo.id === currentConversation?.id} isNewAllConversationScreenEnabled={isNewAllConversationScreenEnabled} isSpinnerOverlayConversationIconEnabled={isSpinnerOverlayConversationIconEnabled} isNewDesignEnabled={isNewDesignEnabled} spaces={spaces} isLoadingSpaces={isLoadingSpaces} spaceEmojiProvider={spaceEmojiProvider} cloudId={cloudId} {...props} />);
    if (isADSNavigationEnabled) {
      return <AtlasMenuList testId={`${TESTID_PREFIX}-history-items-${groupIndex}`}>
					{listItems}
				</AtlasMenuList>;
    }
    return <List testId={`${TESTID_PREFIX}-history-items-${groupIndex}`} xcss={isNewDesignEnabled ? listStyles.noPaddingInlineStart : undefined}>
				{listItems}
			</List>;
  };
  const grouped = groupedConversations.map((group, groupIndex) => {
    const conversationList = renderConversationList(group, groupIndex);
    const MenuSectionComponent = isADSNavigationEnabled ? AtlasMenuSection : MenuSection;
    return <MenuSectionComponent key={group.label} isMenuListItem>
				{isADSNavigationEnabled ? <AtlasMenuSectionHeading>{group.label}</AtlasMenuSectionHeading> : <MenuSectionHeading label={group.label}>{group.label}</MenuSectionHeading>}
				{conversationList}
			</MenuSectionComponent>;
  });
  return <>
			{isNewAllConversationScreenEnabled ? renderConversationList({
      label: '',
      conversations: filteredConversations
    }, 0) : grouped}
			<ButtonMenuItem isADSNavigationEnabled={isADSNavigationEnabled} elemBefore={<ViewAllIcon label="" />} onClick={onViewAllConversationsClick}>
				{formatMessage(messages.viewAllConversationsLabel)}
			</ButtonMenuItem>
		</>;
};
export type ChatListItemProps = Omit<ChatListMenuItemsProps, 'conversations' | 'currentConversation' | 'onViewAllConversations'> & {
  testIdDisambiguator: string;
  conversation: Conversation;
  isSelected: boolean;
  isADSNavigationEnabled: boolean;
  isNewAllConversationScreenEnabled: boolean;
  isSpinnerOverlayConversationIconEnabled: boolean;
  spaces: Space[];
  isLoadingSpaces: boolean;
  spaceEmojiProvider: Promise<EmojiProvider>;
  cloudId?: string;
};
export const ChatListItem = ({
  testIdDisambiguator,
  conversation,
  onSelectConversation,
  onConversationRename,
  onConversationDelete,
  onConversationMoveToSpace,
  onConversationMoveToNewSpace,
  isSelected,
  // assumption: for now, we will only render 1 level of expandable menu items
  level = 1,
  isADSNavigationEnabled,
  isNewAllConversationScreenEnabled,
  isSpinnerOverlayConversationIconEnabled,
  isNewDesignEnabled = false,
  spaces,
  isLoadingSpaces,
  spaceEmojiProvider,
  cloudId
}: ChatListItemProps): JSX.Element => {
  const {
    id,
    name
  } = conversation;
  const {
    formatMessage
  } = useIntl();
  const {
    sendAnalyticsEvent
  } = useAnalytics();
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const [isMoveToSpaceOpen, setIsMoveToSpaceOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [localConversationName, setLocalConversationName] = useState(name);
  const [usingLocalConversationName, setUsingLocalConversationName] = useState(false);
  const [fileScopePreview, setFileScopePreview] = useState<{
    link: string;
    name: string;
  } | null>(null);
  const formRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const {
    setStagingAreaMode
  } = useStagingAreaActions();
  const relativeTime = useUpdateTime({
    isoDate: conversation.lastMessageTimestamp,
    relativeTimeStyle: 'long'
  });
  const loading = conversation.lastAgentMessageStatus === 'IN_PROGRESS' || isTaskStatusLoadingForConversationRow(conversation.currentTask?.status);
  const agentName = conversation.agent?.agent_name;
  const shouldShowAgentInfo = !conversation.agent?.is_default;
  const scopes = conversation.scopes;
  const firstScope = scopes?.[0];
  const scopesOverflowCount = scopes && scopes.length > 1 ? scopes.length - 1 : 0;
  const showTaskStatusFooterRow = shouldShowConversationTaskStatusFooter(conversation) && isNewDesignEnabled;
  const elemBefore = isNewDesignEnabled ? COLLAPSE_ELEM_BEFORE : isNewAllConversationScreenEnabled ? getChatItemIcon({
    conversation,
    iconSize: 'medium',
    loading,
    isSpinnerOverlayConversationIconEnabled,
    selected: isSelected
  }) : isADSNavigationEnabled ? ATLAS_COLLAPSE_ELEM_BEFORE : COLLAPSE_ELEM_BEFORE;
  const shouldShowUnreadStatus = conversation.readStatus === false;
  const onConversationClick = useCallback((event: React.MouseEvent) => {
    event.preventDefault();
    onSelectConversation(conversation, isADSNavigationEnabled);
    setStagingAreaMode(undefined, undefined);
  }, [onSelectConversation, conversation, isADSNavigationEnabled, setStagingAreaMode]);
  const handleScopeLinkClicked = useCallback((variant: 'default' | 'tooltip') => {
    sendAnalyticsEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'scopeLink',
      attributes: {
        isTooltip: variant === 'tooltip'
      }
    });
  }, [sendAnalyticsEvent]);
  const handleScopeLinkHovered = useCallback(() => {
    sendAnalyticsEvent({
      action: 'hovered',
      actionSubject: 'link',
      actionSubjectId: 'scopeLink',
      attributes: {
        scopeCount: scopes?.length ?? 0
      }
    });
  }, [sendAnalyticsEvent, scopes]);
  const handleToggleMoreMenu = useCallback(() => {
    setIsMoreMenuOpen(prev => !prev);
  }, [setIsMoreMenuOpen]);
  const onRenameBtnClicked = useCallback(() => {
    setIsMoreMenuOpen(false);
    setLocalConversationName(name);
    setIsEditing(true);
  }, [setIsEditing, setIsMoreMenuOpen, name, setLocalConversationName]);
  const onDeleteBtnClicked = useCallback(async () => {
    setIsMoreMenuOpen(false);
    onConversationDelete(conversation);
  }, [onConversationDelete, conversation]);
  const onSubmitRename = useCallback(async (value: string) => {
    const prevName = localConversationName;
    setIsEditing(false);
    setLocalConversationName(value);
    setUsingLocalConversationName(true);
    const {
      hasError
    } = (await onConversationRename(conversation, value)) ?? {};
    if (hasError) {
      setLocalConversationName(prevName);
    }
  }, [conversation, localConversationName, onConversationRename, setIsEditing, setLocalConversationName, setUsingLocalConversationName]);
  const onCancelRename = useCallback(() => {
    setIsEditing(false);
  }, [setIsEditing]);
  useEffect(() => {
    if (!isEditing) {
      return;
    }
    inputRef.current?.focus();
  }, [isEditing]);

  // Close the form automatically when the user clicks elsewhere
  useEffect(() => {
    if (!isEditing) {
      return;
    }
    const handleClickOutside = (event: Event) => {
      if (formRef.current && !formRef.current.contains((event.target as Node))) {
        onCancelRename();
      }
    };
    const unbind = bind(window, {
      type: 'mousedown',
      listener: handleClickOutside,
      options: {
        capture: true
      }
    });
    return unbind;
  }, [isEditing, onCancelRename]);
  const moveToSpaceSubmenu = (onConversationMoveToSpace || onConversationMoveToNewSpace) && fg('rovo_chat_spaces_fe') ? <Popup testId={`${TESTID_PREFIX}-move-to-space-popup-${testIdDisambiguator}`} isOpen={isMoveToSpaceOpen} onClose={() => setIsMoveToSpaceOpen(false)} zIndex={Z_INDEX_POPUP_COMPONENTS + 1} placement="right-start" content={() => <MenuGroup>
						{onConversationMoveToNewSpace && <Section>
								<ButtonItem testId={`${TESTID_PREFIX}-move-to-new-space-${testIdDisambiguator}`} iconBefore={<FolderAddIcon label="" />} onClick={() => {
        setIsMoveToSpaceOpen(false);
        setIsMoreMenuOpen(false);
        onConversationMoveToNewSpace(conversation);
      }}>
									{formatMessage(messages.moveToSpaceCreateNewLabel)}
								</ButtonItem>
							</Section>}
						<Section hasSeparator={!!onConversationMoveToNewSpace}>
							{isLoadingSpaces ? <ButtonItem isDisabled iconBefore={<Spinner size="small" label="" />}>
									{formatMessage(messages.moveToSpaceLoadingLabel)}
								</ButtonItem> : spaces.length === 0 ? <ButtonItem isDisabled>
									{formatMessage(messages.moveToSpaceNoSpacesLabel)}
								</ButtonItem> : spaces.map(space => <ButtonItem key={space.id} testId={`${TESTID_PREFIX}-move-to-space-item-${space.id}-${testIdDisambiguator}`} iconBefore={space.emoji ? <ResourcedEmoji emojiId={{
        id: space.emoji,
        shortName: ''
      }} emojiProvider={spaceEmojiProvider} fitToHeight={16} /> : <FolderClosedIcon label="" />} onClick={async () => {
        setIsMoveToSpaceOpen(false);
        setIsMoreMenuOpen(false);
        await onConversationMoveToSpace?.(conversation, space.id);
      }}>
										{space.name}
									</ButtonItem>)}
						</Section>
					</MenuGroup>} trigger={triggerProps => <ButtonItem {...triggerProps} testId={`${TESTID_PREFIX}-history-item-move-to-space-${testIdDisambiguator}`} iconBefore={<FolderClosedIcon label="" />} iconAfter={<ChevronRightIcon label="" />} onClick={() => setIsMoveToSpaceOpen(prev => !prev)}>
						{formatMessage(messages.moreMenuMoveToSpaceLabel)}
					</ButtonItem>} /> : null;
  const moreMenu = <Popup testId={`${TESTID_PREFIX}-more-popup-${testIdDisambiguator}`} isOpen={isMoreMenuOpen} onClose={() => {
    setIsMoreMenuOpen(false);
    setIsMoveToSpaceOpen(false);
  }} zIndex={Z_INDEX_POPUP_COMPONENTS} content={() => {
    return <MenuGroup>
						<ButtonItem testId={`${TESTID_PREFIX}-history-item-rename-${testIdDisambiguator}`} iconBefore={<EditIcon label="" />} onClick={onRenameBtnClicked}>
							{formatMessage(messages.moreMenuRenameLabel)}
						</ButtonItem>
						{moveToSpaceSubmenu}
						<ButtonItem testId={`${TESTID_PREFIX}-history-item-delete-${testIdDisambiguator}`} iconBefore={<DeleteIcon label="" color={"var(--ds-icon-danger, #C9372C)"} />} onClick={onDeleteBtnClicked}>
							{formatMessage(messages.moreMenuDeleteLabel)}
						</ButtonItem>
					</MenuGroup>;
  }} trigger={triggerProps => <IconButton {...triggerProps} testId={`${TESTID_PREFIX}-history-item-more-${testIdDisambiguator}`} icon={() => <MoreIcon label="" size="small" />} appearance="subtle" spacing="compact" onClick={handleToggleMoreMenu} label={formatMessage(commonMessages.moreBtnLabel)} />} placement="bottom-end" />;
  const renameForm = <div ref={formRef} className={ax([styles.renameForm])}>
			{fg('platform-design_system_team-form_conversion') ? <Form onSubmit={(data: {
      conversationName: string;
    }) => {
      onSubmitRename(data.conversationName);
    }} formProps={{
      class: styles.innerForm
    }}>
					<Box xcss={styles.textFieldContainer}>
						<Field name="conversationName" defaultValue={localConversationName}>
							{({
            fieldProps
          }) => <input {...fieldProps} ref={inputRef} aria-label={formatMessage(messages.renameInputLabel)} onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'Escape') {
              onCancelRename();
            }
          }} data-testid={`${TESTID_PREFIX}-convo-name-edit-${testIdDisambiguator}`} className={ax([styles.textField])} />}
						</Field>
					</Box>
					<IconButton icon={iconProps => <CheckMarkIcon {...iconProps} color={"var(--ds-icon-accent-green, #22A06B)"} />} type="submit" appearance="subtle" shape="circle" spacing="compact" label={formatMessage(messages.confirmRenameLabel)} testId={`${TESTID_PREFIX}-rename-confirm-${testIdDisambiguator}`} />
					<IconButton icon={iconProps => <CrossIcon {...iconProps} color={"var(--ds-icon-accent-red, #C9372C)"} />} type="button" onClick={onCancelRename} appearance="subtle" shape="circle" spacing="compact" label={formatMessage(messages.cancelRenameLabel)} testId={`${TESTID_PREFIX}-rename-cancel-${testIdDisambiguator}`} />
				</Form> : <Form onSubmit={(data: {
      conversationName: string;
    }) => {
      onSubmitRename(data.conversationName);
    }}>
					{({
        formProps
      }) => <form {...formProps} className={ax([styles.innerForm])}>
							<Box xcss={styles.textFieldContainer}>
								<Field name="conversationName" defaultValue={localConversationName}>
									{({
              fieldProps
            }) => <input {...fieldProps} ref={inputRef} aria-label={formatMessage(messages.renameInputLabel)} onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Escape') {
                onCancelRename();
              }
            }} data-testid={`${TESTID_PREFIX}-convo-name-edit-${testIdDisambiguator}`} className={ax([styles.textField])} />}
								</Field>
							</Box>
							<IconButton icon={iconProps => <CheckMarkIcon {...iconProps} color={"var(--ds-icon-accent-green, #22A06B)"} />} type="submit" appearance="subtle" shape="circle" spacing="compact" label={formatMessage(messages.confirmRenameLabel)} testId={`${TESTID_PREFIX}-rename-confirm-${testIdDisambiguator}`} />
							<IconButton icon={iconProps => <CrossIcon {...iconProps} color={"var(--ds-icon-accent-red, #C9372C)"} />} type="button" onClick={onCancelRename} appearance="subtle" shape="circle" spacing="compact" label={formatMessage(messages.cancelRenameLabel)} testId={`${TESTID_PREFIX}-rename-cancel-${testIdDisambiguator}`} />
						</form>}
				</Form>}
		</div>;
  if (isEditing) {
    return renameForm;
  }
  const footerTextColor = isNewDesignEnabled ? 'color.text.subtlest' : 'color.text.subtle';
  return <>
			<LinkMenuItem isADSNavigationEnabled={isADSNavigationEnabled} isContentTooltipDisabled href="#" testId={`${TESTID_PREFIX}-history-item-${testIdDisambiguator}`} level={level} key={id} onClick={onConversationClick} actionsOnHover={moreMenu} isSelected={isSelected} isNewAllConversationScreenEnabled={isNewAllConversationScreenEnabled} size={isNewDesignEnabled ? 'small' : isNewAllConversationScreenEnabled ? 'large' : undefined} elemBefore={elemBefore} isNewDesignEnabled={isNewDesignEnabled} noActiveBackground {...isNewAllConversationScreenEnabled && {
      description: <Inline alignBlock="center" space="space.050">
							{/* Shimmer: running-task traces or fixed copy when awaiting user confirmation */}
							{showTaskStatusFooterRow && <ConversationStatusLabel conversation={conversation} showStatusIcon={false} />}
							{!showTaskStatusFooterRow && shouldShowAgentInfo && conversation.agent && <React.Fragment>
									<AgentAvatar agentNamedId={conversation.agent.agent_named_id} agentId={conversation.agent.agent_id} agentIdentityAccountId={conversation.agent.identity_account_id} size="xsmall" showBorder={false} isForgeAgent={fg('rovo_agent_support_a2a_avatar') ? isForgeAgentByCreatorType((conversation.agent.creator_type as AgentCreatorType)) : conversation.agent.creator_type === 'THIRD_PARTY' || conversation.agent.creator_type === 'FORGE'} forgeAgentIconUrl={conversation.agent.forge_url} />
									<Text size="small" weight="regular" maxLines={1} align="start" color={footerTextColor}>
										{agentName}
									</Text>
								</React.Fragment>}
							{!showTaskStatusFooterRow && firstScope && <React.Fragment>
									{shouldShowAgentInfo && conversation.agent && <Text size="small" color={footerTextColor}>
											{formatMessage(messages.footerSeparator)}
										</Text>}
									<Tooltip content={<Stack space="space.100">
												{(scopes ?? []).map((scope, index) => <Box key={`${scope.link ?? 'scope'}-${index}`}>
														<ScopeRow scope={scope} variant="tooltip" maxLines={2} onFilePreview={(link, name) => setFileScopePreview({
                link,
                name
              })} isNewDesignEnabled={isNewDesignEnabled} onScopeLinkClick={handleScopeLinkClicked} />
													</Box>)}
											</Stack>} delay={0} position="bottom" tag="span">
										{tooltipProps => <Box as="span" xcss={styles.firstScopeTooltipTrigger} {...tooltipProps}>
												<Inline alignBlock="center" space="space.050">
													<Box xcss={styles.scopeNameWrapper}>
														<ScopeRow scope={firstScope} variant="default" maxLines={1} onFilePreview={(link, name) => setFileScopePreview({
                    link,
                    name
                  })} isNewDesignEnabled={isNewDesignEnabled} onScopeLinkClick={handleScopeLinkClicked} onScopeLinkHover={handleScopeLinkHovered} />
													</Box>
													{scopesOverflowCount > 0 && <Box as="span" xcss={styles.scopeOverflowCount}>
															<Text as="span" size="small" weight="regular" align="start" color={footerTextColor}>
																{formatMessage(messages.scopesOverflowCount, {
                      count: scopesOverflowCount
                    })}
															</Text>
														</Box>}
												</Inline>
											</Box>}
									</Tooltip>
								</React.Fragment>}
							{relativeTime && <React.Fragment>
									{(shouldShowAgentInfo && conversation.agent || firstScope || showTaskStatusFooterRow) && <Text size="small" color={footerTextColor}>
											{formatMessage(messages.footerSeparator)}
										</Text>}
									<Text size="small" weight="regular" maxLines={1} align="start" color={footerTextColor}>
										{relativeTime}
									</Text>
								</React.Fragment>}
						</Inline>,
      elemAfter: <Box xcss={styles.elemAfterStyles}>
							{isNewDesignEnabled ? <Box xcss={styles.statusContainer}>
									<ConversationListRowStatusChip conversation={conversation} />
								</Box> : <>
									{!isSpinnerOverlayConversationIconEnabled && loading && <Spinner size="small" label="Loading" />}
									{shouldShowUnreadStatus && <Box xcss={styles.notificationDot} />}
								</>}
						</Box>
    }}>
				{usingLocalConversationName ? localConversationName : name}
			</LinkMenuItem>
			{fileScopePreview ? <ScopeFileBlobPreviewModal isOpen onClose={() => setFileScopePreview(null)} fileUrl={fileScopePreview.link} fileName={fileScopePreview.name} formatMessage={formatMessage} filePreviewFallbackDescription={messages.filePreviewFallbackDescription} cloudId={cloudId} /> : null}
		</>;
};